<template>
    <div id="content-import" class="modal inmodal fade" role="dialog" aria-hidden="true" data-backdrop="static"
         tabindex="-1">
        <div class="modal-dialog">
            <div class="modal-content animated fadeInUp">
                <modal-header :title="t_upload"/>
                <div class="modal-body">
                    <div class="row m-b-sm">
                        <div class="col-lg-12">
                            <div class="float-e-margins">
                                <div class="file-manager">
                                    <form id="dropzone-content-import" class="dropzone-box import-dropzone-scrollbox">
                                        <div class="dz-default dz-message"><span>{{ t_drop_upload }}</span></div>
                                    </form>
                                    <v-btn class="btn btn-primary btn-block fileinput-button m-t-sm">
                                        {{ t_upload }}
                                    </v-btn>
                                </div>
                            </div>
                        </div>
                        <div class="table import-dropzone-preview table-striped files hidden" id="upload-preview">
                            <div id="template" class="file-row">
                                <div>
                                    <strong class="error text-danger" data-dz-errormessage></strong>
                                </div>
                                <div class="progress import-dropzone-progress progress-striped active">
                                    <div aria-valuemax="100" aria-valuemin="0" aria-valuenow="0" role="progressbar"
                                         class="progress-bar"
                                         data-dz-uploadprogress>
                                        <p class="name import-dropzone-filename" data-dz-name></p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="show_summary === true" class="row">
                        <div class="col-lg-12">
                            <div v-for="(uploaded_file, filename) in imports" class="border-top border-size-sm m-t-sm">
                                <h3>{{ filename }}</h3>
                                <div v-for="importElement in uploaded_file" class="row m-t-sm">
                                    <div class="col-lg-12 p-sm">
                                        <h4>{{ importElement.title }}</h4>
                                        <p v-if="importElement.main !== ''">{{ importElement.main }}</p>
                                        <h6 v-if="importElement.media.length === 0">{{ t_media + ': ' + t_none }}</h6>
                                        <template v-else>
                                            <h6>{{ t_media }}:</h6>
                                            <ul>
                                                <li v-for="m in importElement.media">
                                                    {{ m }}
                                                </li>
                                            </ul>
                                        </template>

                                        <h6 v-if="importElement.template.length === 0">{{ t_templates + ': ' + t_none }}</h6>
                                        <template v-else>
                                            <h6>{{ t_templates }}:</h6>
                                            <ul>
                                                <li v-for="t in importElement.template">
                                                    {{ t }}
                                                </li>
                                            </ul>
                                        </template>

                                        <h6 v-if="importElement.campaign.length === 0">{{ t_campaigns + ': ' + t_none }}</h6>
                                        <template v-else>
                                            <h6>{{ t_campaigns }}:</h6>
                                            <ul>
                                                <li v-for="t in importElement.campaign">
                                                    {{ t }}
                                                </li>
                                            </ul>
                                        </template>

                                        <h6 v-if="importElement.widget.length === 0">{{ t_widgets + ': ' + t_none }}</h6>
                                        <template v-else>
                                            <h6>{{ t_widgets }}:</h6>
                                            <ul>
                                                <li v-for="t in importElement.widget">
                                                    {{ t }}
                                                </li>
                                            </ul>
                                        </template>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import toaster from "../common/toaster";
    import Dropzone from "@deltablot/dropzone";

    export default {
        data: function () {
            return {
                t_close: Lang.langGet("Close"),
                t_upload: Lang.langGet("Upload Files"),
                t_drop_upload: Lang.langGet("Drop files here to upload and import"),
                t_unknown: Lang.langGet("Unknown"),
                t_import_success: Lang.langGet("The file was successfully imported!"),
                t_import_failed: Lang.langGet("Failed to import the file!"),
                t_import: Lang.langGet("Imported"),
                t_linked: Lang.langGet("Previously already imported"),
                t_media: Lang.langChoice("Media|Medien", 2),
                t_templates: Lang.langChoice("Template|Templates", 2),
                t_campaigns: Lang.langChoice("Campaign|Campaigns", 2),
                t_widgets: Lang.langChoice("Widget|Widgets", 2),
                t_none: Lang.langGet("None"),
                fileReference: 0,
                dropzoneObject: null,
                imports: {},
                show_summary: false
            }
        },
        methods: {
            reset: function () {
                this.init();
            },
            increaseFileReference: function () {
                this.fileReference += 1;

                if (this.fileReference > 0) {
                    $('#dropzone-content-import .dz-message').addClass('hidden');
                }
            },
            dereaseFileReference: function () {
                this.fileReference -= 1;

                if (this.fileReference <= 0) {
                    $('#dropzone-content-import .dz-message').removeClass('hidden');
                }
            },
            init: function () {
                this.dropzoneObject = new Dropzone('#dropzone-content-import', {
                    url: '/content/import/upload',
                    paramName: 'file',
                    timeout: 300000,
                    parallelUploads: 1,
                    chunking: true,
                    maxFilesize: Laravel.upload_max_filesize,
                    previewTemplate: document.getElementById('upload-preview').innerHTML,
                    acceptedFiles: ['.zip'].join(','),
                    headers: {
                        'X-CSRF-TOKEN': Laravel.csrfToken
                    },
                    dictDefaultMessage: Lang.langGet("Drop files here to upload and import"),
                    clickable: '.fileinput-button',
                    'error': (file, response) => {
                        if(file.previewElement) {
                            $(file.previewElement).find('[role=progressbar]').css('width', '100%');
                        }
                        toaster.error(this.t_import_failed);
                    },
                    'chunksUploaded': (file, done) => {
                        if(file.previewElement) {
                            file.previewElement.querySelector('.dz-processing .progress.active .progress-bar').style.width = '100%';
                        }
                        done();
                    },
                    'uploadprogress': (file, progress, bytesSent) => {
                        if(file.previewElement) {
                            file.previewElement.querySelector('.progress.active .progress-bar').style.width = progress + '%';
                        }
                    },
                    'complete': (file) => {
                        let timeout = 0;

                        if (file.status === 'error') {
                            timeout = 10000;
                        }

                        setTimeout(() => {
                            this.dropzoneObject.removeFile(file);
                            this.dereaseFileReference();
                        }, timeout);
                    },
                    'success': (response) => {
                        let responseJSON = JSON.parse(response.xhr.responseText);
                        let filename = responseJSON.elements.imported.filename;
                        let structureImports = {
                            title: this.t_import,
                            main: responseJSON.elements.imported.main,
                            media: responseJSON.elements.imported.media,
                            template: responseJSON.elements.imported.template,
                            campaign: responseJSON.elements.imported.campaign,
                            widget: responseJSON.elements.imported.widget
                        }
                        let structureLinks = {
                            title: this.t_linked,
                            main: responseJSON.elements.linked.main,
                            media: responseJSON.elements.linked.media,
                            template: responseJSON.elements.linked.template,
                            campaign: responseJSON.elements.linked.campaign,
                            widget: responseJSON.elements.linked.widget
                        }
                        Vue.set(this.imports, filename, [
                            structureImports, structureLinks
                        ]);
                        this.show_summary = true;
                        toaster.success(this.t_import_success);
                        EaseEventBus.fire('reloadData');
                    }
                });

                this.dropzoneObject.on('addedfile', (file) => {
                    this.show_summary = false;
                    this.increaseFileReference();
                });
            }
        },
        mounted() {
            this.init();

            EaseEventBus.listen('hideModal', (modal) => {
                if (modal === 'content-import') {
                    this.show_summary = false;
                    this.imports = {};
                }
            });
        }
    }
</script>
